import { EventNames } from "../constants";
import { LogMessage } from "../helper-func";
export function InitializeUserEvents(document, userSignIn, userSignOut, userIconClicked) {
    document.addEventListener(EventNames.UserSignedIn, (event) => {
        const userInfo = event.detail;
        LogMessage(`EventNames.UserSignedIn is triggered: ${JSON.stringify(userInfo)}`);
        const userProfile = document.querySelector('user-profile');
        if (userProfile) {
            userProfile.fetchUserProfile();
        }
        if (userSignIn) {
            userSignIn(event);
        }
    });
    document.addEventListener(EventNames.UserSignedOut, (event) => {
        LogMessage('EventNames.UserSignedOut is triggered.');
        const userStatus = document.querySelector('user-status');
        if (userStatus) {
            userStatus.clearUserInfo();
        }
        const userProfile = document.querySelector('user-profile');
        if (userProfile) {
            userProfile.clearUserProfile();
        }
        if (userSignOut) {
            userSignOut(event);
        }
    });
    document.addEventListener(EventNames.UserIconClicked, (event) => {
        LogMessage("EventNames.UserIconClicked is triggered.");
        const userProfile = document.querySelector('user-profile');
        if (userProfile) {
            userProfile.open();
        }
        if (userIconClicked) {
            userIconClicked(event);
        }
    });
}
